import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d5274abc = () => interopDefault(import('../client/pages/ask-the-nutritionist.vue' /* webpackChunkName: "pages/ask-the-nutritionist" */))
const _5613b56e = () => interopDefault(import('../client/pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _1ef59b50 = () => interopDefault(import('../client/pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _130416b5 = () => interopDefault(import('../client/pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _66dc0503 = () => interopDefault(import('../client/pages/free_trial.vue' /* webpackChunkName: "pages/free_trial" */))
const _75fa2fc8 = () => interopDefault(import('../client/pages/get_started.vue' /* webpackChunkName: "pages/get_started" */))
const _d084438e = () => interopDefault(import('../client/pages/giveaway-terms.vue' /* webpackChunkName: "pages/giveaway-terms" */))
const _fe9fecb6 = () => interopDefault(import('../client/pages/gummy_samples.vue' /* webpackChunkName: "pages/gummy_samples" */))
const _3bf49fe2 = () => interopDefault(import('../client/pages/instagram.vue' /* webpackChunkName: "pages/instagram" */))
const _4229a656 = () => interopDefault(import('../client/pages/jobs.vue' /* webpackChunkName: "pages/jobs" */))
const _2667e019 = () => interopDefault(import('../client/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _3cf1979d = () => interopDefault(import('../client/pages/my_account/index.vue' /* webpackChunkName: "pages/my_account/index" */))
const _2121d571 = () => interopDefault(import('../client/pages/nutritionists.vue' /* webpackChunkName: "pages/nutritionists" */))
const _3451cb38 = () => interopDefault(import('../client/pages/our-story.vue' /* webpackChunkName: "pages/our-story" */))
const _860ec778 = () => interopDefault(import('../client/pages/personalize.vue' /* webpackChunkName: "pages/personalize" */))
const _45df5f87 = () => interopDefault(import('../client/pages/plan-and-save.vue' /* webpackChunkName: "pages/plan-and-save" */))
const _56a797f3 = () => interopDefault(import('../client/pages/press.vue' /* webpackChunkName: "pages/press" */))
const _7621a6b8 = () => interopDefault(import('../client/pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _5b3c928f = () => interopDefault(import('../client/pages/product-philosophy.vue' /* webpackChunkName: "pages/product-philosophy" */))
const _98921f38 = () => interopDefault(import('../client/pages/products.vue' /* webpackChunkName: "pages/products" */))
const _09dfaa0a = () => interopDefault(import('../client/pages/recommendations.vue' /* webpackChunkName: "pages/recommendations" */))
const _968da892 = () => interopDefault(import('../client/pages/refer-a-friend.vue' /* webpackChunkName: "pages/refer-a-friend" */))
const _60db57d9 = () => interopDefault(import('../client/pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _a5b560d8 = () => interopDefault(import('../client/pages/science.vue' /* webpackChunkName: "pages/science" */))
const _e3cc5d36 = () => interopDefault(import('../client/pages/sitemap.vue' /* webpackChunkName: "pages/sitemap" */))
const _33ecec74 = () => interopDefault(import('../client/pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _afd48f74 = () => interopDefault(import('../client/pages/wholesale-inquiries.vue' /* webpackChunkName: "pages/wholesale-inquiries" */))
const _4030f08e = () => interopDefault(import('../client/pages/checkout/confirmation.vue' /* webpackChunkName: "pages/checkout/confirmation" */))
const _1bcebefc = () => interopDefault(import('../client/pages/my_account/cancel/index.vue' /* webpackChunkName: "pages/my_account/cancel/index" */))
const _3b3bad63 = () => interopDefault(import('../client/pages/my_account/customer.vue' /* webpackChunkName: "pages/my_account/customer" */))
const _09779bca = () => interopDefault(import('../client/pages/my_account/membership.vue' /* webpackChunkName: "pages/my_account/membership" */))
const _2a19ec0e = () => interopDefault(import('../client/pages/my_account/nutrition-report.vue' /* webpackChunkName: "pages/my_account/nutrition-report" */))
const _32c951e3 = () => interopDefault(import('../client/pages/my_account/order-history/index.vue' /* webpackChunkName: "pages/my_account/order-history/index" */))
const _38a405cf = () => interopDefault(import('../client/pages/my_account/routine.vue' /* webpackChunkName: "pages/my_account/routine" */))
const _b5a87846 = () => interopDefault(import('../client/pages/my_account/cancel/account-issues/index.vue' /* webpackChunkName: "pages/my_account/cancel/account-issues/index" */))
const _6afdd996 = () => interopDefault(import('../client/pages/my_account/cancel/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/confirmation" */))
const _7a42e12a = () => interopDefault(import('../client/pages/my_account/cancel/cs-issues/index.vue' /* webpackChunkName: "pages/my_account/cancel/cs-issues/index" */))
const _65d02c7c = () => interopDefault(import('../client/pages/my_account/cancel/financial/index.vue' /* webpackChunkName: "pages/my_account/cancel/financial/index" */))
const _55e5b7bf = () => interopDefault(import('../client/pages/my_account/cancel/member-benefits.vue' /* webpackChunkName: "pages/my_account/cancel/member-benefits" */))
const _1334413a = () => interopDefault(import('../client/pages/my_account/cancel/new-concerns/index.vue' /* webpackChunkName: "pages/my_account/cancel/new-concerns/index" */))
const _5af5f70a = () => interopDefault(import('../client/pages/my_account/cancel/not-finished-yet/index.vue' /* webpackChunkName: "pages/my_account/cancel/not-finished-yet/index" */))
const _a0e9c54a = () => interopDefault(import('../client/pages/my_account/cancel/product-issues/index.vue' /* webpackChunkName: "pages/my_account/cancel/product-issues/index" */))
const _5575eaa9 = () => interopDefault(import('../client/pages/my_account/cancel/subscriptions/index.vue' /* webpackChunkName: "pages/my_account/cancel/subscriptions/index" */))
const _51f59cdd = () => interopDefault(import('../client/pages/my_account/cancel/survey/index.vue' /* webpackChunkName: "pages/my_account/cancel/survey/index" */))
const _30b7accd = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/index.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/index" */))
const _b2404fd0 = () => interopDefault(import('../client/pages/my_account/cancel/financial/change-date/index.vue' /* webpackChunkName: "pages/my_account/cancel/financial/change-date/index" */))
const _7fa60c0a = () => interopDefault(import('../client/pages/my_account/cancel/financial/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/financial/confirmation" */))
const _c37063fa = () => interopDefault(import('../client/pages/my_account/cancel/financial/upgrade-plan/index.vue' /* webpackChunkName: "pages/my_account/cancel/financial/upgrade-plan/index" */))
const _44412ef0 = () => interopDefault(import('../client/pages/my_account/cancel/new-concerns/ask-nutritionist/index.vue' /* webpackChunkName: "pages/my_account/cancel/new-concerns/ask-nutritionist/index" */))
const _85eaf1aa = () => interopDefault(import('../client/pages/my_account/cancel/new-concerns/recommendations.vue' /* webpackChunkName: "pages/my_account/cancel/new-concerns/recommendations" */))
const _875784b4 = () => interopDefault(import('../client/pages/my_account/cancel/not-finished-yet/change-date/index.vue' /* webpackChunkName: "pages/my_account/cancel/not-finished-yet/change-date/index" */))
const _189258a6 = () => interopDefault(import('../client/pages/my_account/cancel/not-finished-yet/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/not-finished-yet/confirmation" */))
const _11ec6a36 = () => interopDefault(import('../client/pages/my_account/cancel/product-issues/how-to-take.vue' /* webpackChunkName: "pages/my_account/cancel/product-issues/how-to-take" */))
const _04504a18 = () => interopDefault(import('../client/pages/my_account/cancel/product-issues/no-results/index.vue' /* webpackChunkName: "pages/my_account/cancel/product-issues/no-results/index" */))
const _e20c4620 = () => interopDefault(import('../client/pages/my_account/cancel/product-issues/product-too-large/index.vue' /* webpackChunkName: "pages/my_account/cancel/product-issues/product-too-large/index" */))
const _72e0bac5 = () => interopDefault(import('../client/pages/my_account/cancel/subscriptions/change-date/index.vue' /* webpackChunkName: "pages/my_account/cancel/subscriptions/change-date/index" */))
const _3eca5f2e = () => interopDefault(import('../client/pages/my_account/cancel/subscriptions/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/subscriptions/confirmation" */))
const _9f48eb0c = () => interopDefault(import('../client/pages/my_account/cancel/survey/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/survey/confirmation" */))
const _d17b1a84 = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/address-change.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/address-change" */))
const _50f7db2e = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/financial-reasons/index.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/financial-reasons/index" */))
const _06dc95d4 = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/health-reasons/index.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/health-reasons/index" */))
const _68000b66 = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/maternal-reasons/index.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/maternal-reasons/index" */))
const _a29f6296 = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/vacation/index.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/vacation/index" */))
const _93237242 = () => interopDefault(import('../client/pages/my_account/cancel/financial/change-date/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/financial/change-date/confirmation" */))
const _6e663ad8 = () => interopDefault(import('../client/pages/my_account/cancel/financial/upgrade-plan/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/financial/upgrade-plan/confirmation" */))
const _e35f4f22 = () => interopDefault(import('../client/pages/my_account/cancel/new-concerns/ask-nutritionist/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/new-concerns/ask-nutritionist/confirmation" */))
const _67d5b4de = () => interopDefault(import('../client/pages/my_account/cancel/not-finished-yet/change-date/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/not-finished-yet/change-date/confirmation" */))
const _34383dd2 = () => interopDefault(import('../client/pages/my_account/cancel/product-issues/no-results/ask-nutritionist/index.vue' /* webpackChunkName: "pages/my_account/cancel/product-issues/no-results/ask-nutritionist/index" */))
const _e302d2ca = () => interopDefault(import('../client/pages/my_account/cancel/product-issues/product-too-large/ask-nutritionist/index.vue' /* webpackChunkName: "pages/my_account/cancel/product-issues/product-too-large/ask-nutritionist/index" */))
const _67367792 = () => interopDefault(import('../client/pages/my_account/cancel/subscriptions/change-date/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/subscriptions/change-date/confirmation" */))
const _28314285 = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/financial-reasons/change-date/index.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/financial-reasons/change-date/index" */))
const _27b3ff6e = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/financial-reasons/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/financial-reasons/confirmation" */))
const _4723b136 = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/financial-reasons/upgrade-plan/index.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/financial-reasons/upgrade-plan/index" */))
const _5b977021 = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/health-reasons/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/health-reasons/confirmation" */))
const _184b405e = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/maternal-reasons/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/maternal-reasons/confirmation" */))
const _21c96cd1 = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/vacation/change-date/index.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/vacation/change-date/index" */))
const _7734d4bc = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/vacation/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/vacation/confirmation" */))
const _64c61e00 = () => interopDefault(import('../client/pages/my_account/cancel/product-issues/no-results/ask-nutritionist/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/product-issues/no-results/ask-nutritionist/confirmation" */))
const _2ed08208 = () => interopDefault(import('../client/pages/my_account/cancel/product-issues/product-too-large/ask-nutritionist/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/product-issues/product-too-large/ask-nutritionist/confirmation" */))
const _811c905c = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/financial-reasons/change-date/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/financial-reasons/change-date/confirmation" */))
const _3f90dffe = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/financial-reasons/upgrade-plan/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/financial-reasons/upgrade-plan/confirmation" */))
const _130fa006 = () => interopDefault(import('../client/pages/my_account/cancel/taking-a-break/vacation/change-date/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/taking-a-break/vacation/change-date/confirmation" */))
const _7617559e = () => interopDefault(import('../client/pages/my_account/cancel/account-issues/_reason/index.vue' /* webpackChunkName: "pages/my_account/cancel/account-issues/_reason/index" */))
const _27985504 = () => interopDefault(import('../client/pages/my_account/cancel/cs-issues/_reason/index.vue' /* webpackChunkName: "pages/my_account/cancel/cs-issues/_reason/index" */))
const _71c08ba6 = () => interopDefault(import('../client/pages/my_account/cancel/account-issues/_reason/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/account-issues/_reason/confirmation" */))
const _4acb8ab9 = () => interopDefault(import('../client/pages/my_account/cancel/cs-issues/_reason/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/cs-issues/_reason/confirmation" */))
const _218f1dea = () => interopDefault(import('../client/pages/my_account/order-history/_id.vue' /* webpackChunkName: "pages/my_account/order-history/_id" */))
const _20c868ea = () => interopDefault(import('../client/pages/product/_productId.vue' /* webpackChunkName: "pages/product/_productId" */))
const _5cc03d02 = () => interopDefault(import('../client/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _130e534d = () => interopDefault(import('../client/pages/_landing/checkout.vue' /* webpackChunkName: "pages/_landing/checkout" */))
const _316387ba = () => interopDefault(import('../client/pages/_landing/recommendations.vue' /* webpackChunkName: "pages/_landing/recommendations" */))
const _56153e2a = () => interopDefault(import('../client/pages/_landing/register.vue' /* webpackChunkName: "pages/_landing/register" */))
const _0d219c8a = () => interopDefault(import('../client/pages/_landing/quiz/_questionNumber.vue' /* webpackChunkName: "pages/_landing/quiz/_questionNumber" */))
const _ff946996 = () => interopDefault(import('~/pages/product/_productId.vue' /* webpackChunkName: "" */))
const _c71ac6e4 = () => interopDefault(import('~/pages/products.vue' /* webpackChunkName: "" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ask-the-nutritionist",
    component: _d5274abc,
    name: "ask-the-nutritionist"
  }, {
    path: "/checkout",
    component: _5613b56e,
    name: "checkout"
  }, {
    path: "/contact",
    component: _1ef59b50,
    name: "contact"
  }, {
    path: "/forgot-password",
    component: _130416b5,
    name: "forgot-password"
  }, {
    path: "/free_trial",
    component: _66dc0503,
    name: "free_trial"
  }, {
    path: "/get_started",
    component: _75fa2fc8,
    name: "get_started"
  }, {
    path: "/giveaway-terms",
    component: _d084438e,
    name: "giveaway-terms"
  }, {
    path: "/gummy_samples",
    component: _fe9fecb6,
    name: "gummy_samples"
  }, {
    path: "/instagram",
    component: _3bf49fe2,
    name: "instagram"
  }, {
    path: "/jobs",
    component: _4229a656,
    name: "jobs"
  }, {
    path: "/login",
    component: _2667e019,
    name: "login"
  }, {
    path: "/my_account",
    component: _3cf1979d,
    name: "my_account"
  }, {
    path: "/nutritionists",
    component: _2121d571,
    name: "nutritionists"
  }, {
    path: "/our-story",
    component: _3451cb38,
    name: "our-story"
  }, {
    path: "/personalize",
    component: _860ec778,
    name: "personalize"
  }, {
    path: "/plan-and-save",
    component: _45df5f87,
    name: "plan-and-save"
  }, {
    path: "/press",
    component: _56a797f3,
    name: "press"
  }, {
    path: "/privacy",
    component: _7621a6b8,
    name: "privacy"
  }, {
    path: "/product-philosophy",
    component: _5b3c928f,
    name: "product-philosophy"
  }, {
    path: "/products",
    component: _98921f38,
    name: "products"
  }, {
    path: "/recommendations",
    component: _09dfaa0a,
    name: "recommendations"
  }, {
    path: "/refer-a-friend",
    component: _968da892,
    name: "refer-a-friend"
  }, {
    path: "/reset-password",
    component: _60db57d9,
    name: "reset-password"
  }, {
    path: "/science",
    component: _a5b560d8,
    name: "science"
  }, {
    path: "/sitemap",
    component: _e3cc5d36,
    name: "sitemap"
  }, {
    path: "/terms-and-conditions",
    component: _33ecec74,
    name: "terms-and-conditions"
  }, {
    path: "/wholesale-inquiries",
    component: _afd48f74,
    name: "wholesale-inquiries"
  }, {
    path: "/checkout/confirmation",
    component: _4030f08e,
    name: "checkout-confirmation"
  }, {
    path: "/my_account/cancel",
    component: _1bcebefc,
    name: "my_account-cancel"
  }, {
    path: "/my_account/customer",
    component: _3b3bad63,
    name: "my_account-customer"
  }, {
    path: "/my_account/membership",
    component: _09779bca,
    name: "my_account-membership"
  }, {
    path: "/my_account/nutrition-report",
    component: _2a19ec0e,
    name: "my_account-nutrition-report"
  }, {
    path: "/my_account/order-history",
    component: _32c951e3,
    name: "my_account-order-history"
  }, {
    path: "/my_account/routine",
    component: _38a405cf,
    name: "my_account-routine"
  }, {
    path: "/my_account/cancel/account-issues",
    component: _b5a87846,
    name: "my_account-cancel-account-issues"
  }, {
    path: "/my_account/cancel/confirmation",
    component: _6afdd996,
    name: "my_account-cancel-confirmation"
  }, {
    path: "/my_account/cancel/cs-issues",
    component: _7a42e12a,
    name: "my_account-cancel-cs-issues"
  }, {
    path: "/my_account/cancel/financial",
    component: _65d02c7c,
    name: "my_account-cancel-financial"
  }, {
    path: "/my_account/cancel/member-benefits",
    component: _55e5b7bf,
    name: "my_account-cancel-member-benefits"
  }, {
    path: "/my_account/cancel/new-concerns",
    component: _1334413a,
    name: "my_account-cancel-new-concerns"
  }, {
    path: "/my_account/cancel/not-finished-yet",
    component: _5af5f70a,
    name: "my_account-cancel-not-finished-yet"
  }, {
    path: "/my_account/cancel/product-issues",
    component: _a0e9c54a,
    name: "my_account-cancel-product-issues"
  }, {
    path: "/my_account/cancel/subscriptions",
    component: _5575eaa9,
    name: "my_account-cancel-subscriptions"
  }, {
    path: "/my_account/cancel/survey",
    component: _51f59cdd,
    name: "my_account-cancel-survey"
  }, {
    path: "/my_account/cancel/taking-a-break",
    component: _30b7accd,
    name: "my_account-cancel-taking-a-break"
  }, {
    path: "/my_account/cancel/financial/change-date",
    component: _b2404fd0,
    name: "my_account-cancel-financial-change-date"
  }, {
    path: "/my_account/cancel/financial/confirmation",
    component: _7fa60c0a,
    name: "my_account-cancel-financial-confirmation"
  }, {
    path: "/my_account/cancel/financial/upgrade-plan",
    component: _c37063fa,
    name: "my_account-cancel-financial-upgrade-plan"
  }, {
    path: "/my_account/cancel/new-concerns/ask-nutritionist",
    component: _44412ef0,
    name: "my_account-cancel-new-concerns-ask-nutritionist"
  }, {
    path: "/my_account/cancel/new-concerns/recommendations",
    component: _85eaf1aa,
    name: "my_account-cancel-new-concerns-recommendations"
  }, {
    path: "/my_account/cancel/not-finished-yet/change-date",
    component: _875784b4,
    name: "my_account-cancel-not-finished-yet-change-date"
  }, {
    path: "/my_account/cancel/not-finished-yet/confirmation",
    component: _189258a6,
    name: "my_account-cancel-not-finished-yet-confirmation"
  }, {
    path: "/my_account/cancel/product-issues/how-to-take",
    component: _11ec6a36,
    name: "my_account-cancel-product-issues-how-to-take"
  }, {
    path: "/my_account/cancel/product-issues/no-results",
    component: _04504a18,
    name: "my_account-cancel-product-issues-no-results"
  }, {
    path: "/my_account/cancel/product-issues/product-too-large",
    component: _e20c4620,
    name: "my_account-cancel-product-issues-product-too-large"
  }, {
    path: "/my_account/cancel/subscriptions/change-date",
    component: _72e0bac5,
    name: "my_account-cancel-subscriptions-change-date"
  }, {
    path: "/my_account/cancel/subscriptions/confirmation",
    component: _3eca5f2e,
    name: "my_account-cancel-subscriptions-confirmation"
  }, {
    path: "/my_account/cancel/survey/confirmation",
    component: _9f48eb0c,
    name: "my_account-cancel-survey-confirmation"
  }, {
    path: "/my_account/cancel/taking-a-break/address-change",
    component: _d17b1a84,
    name: "my_account-cancel-taking-a-break-address-change"
  }, {
    path: "/my_account/cancel/taking-a-break/financial-reasons",
    component: _50f7db2e,
    name: "my_account-cancel-taking-a-break-financial-reasons"
  }, {
    path: "/my_account/cancel/taking-a-break/health-reasons",
    component: _06dc95d4,
    name: "my_account-cancel-taking-a-break-health-reasons"
  }, {
    path: "/my_account/cancel/taking-a-break/maternal-reasons",
    component: _68000b66,
    name: "my_account-cancel-taking-a-break-maternal-reasons"
  }, {
    path: "/my_account/cancel/taking-a-break/vacation",
    component: _a29f6296,
    name: "my_account-cancel-taking-a-break-vacation"
  }, {
    path: "/my_account/cancel/financial/change-date/confirmation",
    component: _93237242,
    name: "my_account-cancel-financial-change-date-confirmation"
  }, {
    path: "/my_account/cancel/financial/upgrade-plan/confirmation",
    component: _6e663ad8,
    name: "my_account-cancel-financial-upgrade-plan-confirmation"
  }, {
    path: "/my_account/cancel/new-concerns/ask-nutritionist/confirmation",
    component: _e35f4f22,
    name: "my_account-cancel-new-concerns-ask-nutritionist-confirmation"
  }, {
    path: "/my_account/cancel/not-finished-yet/change-date/confirmation",
    component: _67d5b4de,
    name: "my_account-cancel-not-finished-yet-change-date-confirmation"
  }, {
    path: "/my_account/cancel/product-issues/no-results/ask-nutritionist",
    component: _34383dd2,
    name: "my_account-cancel-product-issues-no-results-ask-nutritionist"
  }, {
    path: "/my_account/cancel/product-issues/product-too-large/ask-nutritionist",
    component: _e302d2ca,
    name: "my_account-cancel-product-issues-product-too-large-ask-nutritionist"
  }, {
    path: "/my_account/cancel/subscriptions/change-date/confirmation",
    component: _67367792,
    name: "my_account-cancel-subscriptions-change-date-confirmation"
  }, {
    path: "/my_account/cancel/taking-a-break/financial-reasons/change-date",
    component: _28314285,
    name: "my_account-cancel-taking-a-break-financial-reasons-change-date"
  }, {
    path: "/my_account/cancel/taking-a-break/financial-reasons/confirmation",
    component: _27b3ff6e,
    name: "my_account-cancel-taking-a-break-financial-reasons-confirmation"
  }, {
    path: "/my_account/cancel/taking-a-break/financial-reasons/upgrade-plan",
    component: _4723b136,
    name: "my_account-cancel-taking-a-break-financial-reasons-upgrade-plan"
  }, {
    path: "/my_account/cancel/taking-a-break/health-reasons/confirmation",
    component: _5b977021,
    name: "my_account-cancel-taking-a-break-health-reasons-confirmation"
  }, {
    path: "/my_account/cancel/taking-a-break/maternal-reasons/confirmation",
    component: _184b405e,
    name: "my_account-cancel-taking-a-break-maternal-reasons-confirmation"
  }, {
    path: "/my_account/cancel/taking-a-break/vacation/change-date",
    component: _21c96cd1,
    name: "my_account-cancel-taking-a-break-vacation-change-date"
  }, {
    path: "/my_account/cancel/taking-a-break/vacation/confirmation",
    component: _7734d4bc,
    name: "my_account-cancel-taking-a-break-vacation-confirmation"
  }, {
    path: "/my_account/cancel/product-issues/no-results/ask-nutritionist/confirmation",
    component: _64c61e00,
    name: "my_account-cancel-product-issues-no-results-ask-nutritionist-confirmation"
  }, {
    path: "/my_account/cancel/product-issues/product-too-large/ask-nutritionist/confirmation",
    component: _2ed08208,
    name: "my_account-cancel-product-issues-product-too-large-ask-nutritionist-confirmation"
  }, {
    path: "/my_account/cancel/taking-a-break/financial-reasons/change-date/confirmation",
    component: _811c905c,
    name: "my_account-cancel-taking-a-break-financial-reasons-change-date-confirmation"
  }, {
    path: "/my_account/cancel/taking-a-break/financial-reasons/upgrade-plan/confirmation",
    component: _3f90dffe,
    name: "my_account-cancel-taking-a-break-financial-reasons-upgrade-plan-confirmation"
  }, {
    path: "/my_account/cancel/taking-a-break/vacation/change-date/confirmation",
    component: _130fa006,
    name: "my_account-cancel-taking-a-break-vacation-change-date-confirmation"
  }, {
    path: "/my_account/cancel/account-issues/:reason",
    component: _7617559e,
    name: "my_account-cancel-account-issues-reason"
  }, {
    path: "/my_account/cancel/cs-issues/:reason",
    component: _27985504,
    name: "my_account-cancel-cs-issues-reason"
  }, {
    path: "/my_account/cancel/account-issues/:reason?/confirmation",
    component: _71c08ba6,
    name: "my_account-cancel-account-issues-reason-confirmation"
  }, {
    path: "/my_account/cancel/cs-issues/:reason?/confirmation",
    component: _4acb8ab9,
    name: "my_account-cancel-cs-issues-reason-confirmation"
  }, {
    path: "/my_account/order-history/:id?",
    component: _218f1dea,
    name: "my_account-order-history-id"
  }, {
    path: "/product/:productId?",
    component: _20c868ea,
    name: "product-productId"
  }, {
    path: "/",
    component: _5cc03d02,
    name: "index"
  }, {
    path: "/:landing/checkout",
    component: _130e534d,
    name: "landing-checkout"
  }, {
    path: "/:landing/recommendations",
    component: _316387ba,
    name: "landing-recommendations"
  }, {
    path: "/:landing/register",
    component: _56153e2a,
    name: "landing-register"
  }, {
    path: "/:landing/quiz/:questionNumber?",
    component: _0d219c8a,
    name: "landing-quiz-questionNumber"
  }, {
    path: "/product/:productId/:slug",
    component: _ff946996,
    name: "product"
  }, {
    path: "/products/category/:category",
    component: _c71ac6e4,
    name: "products-category"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decodeURIComponent(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
